import { render, staticRenderFns } from "./GenericListTableV2.vue?vue&type=template&id=682292e7&scoped=true&"
import script from "./GenericListTableV2.vue?vue&type=script&lang=js&"
export * from "./GenericListTableV2.vue?vue&type=script&lang=js&"
import style0 from "./GenericListTableV2.vue?vue&type=style&index=0&id=682292e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682292e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VIcon,VSelect,VSpacer,VTextField})
